// extracted by mini-css-extract-plugin
export default {"employeeCategoryFilter":"employee-filter_employeeCategoryFilter__i7hB2","select":"employee-filter_select__2G1Jw","dropdownContainer":"employee-filter_dropdownContainer__gLIN2"};